var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackedLN(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "19px",
    viewBox: "0 0 33 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "packed_l_n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "library",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04a_book_reader_settings_word",
    transform: "translate(-608.000000, -529.000000)",
    fill: "#AAAAAA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.5,529 L639.5,529 C640.328427,529 641,529.671573 641,530.5 C641,531.328427 640.328427,532 639.5,532 L609.5,532 C608.671573,532 608,531.328427 608,530.5 C608,529.671573 608.671573,529 609.5,529 Z M609.5,537 L632.24,537 C633.068427,537 633.74,537.671573 633.74,538.5 C633.74,539.328427 633.068427,540 632.24,540 L609.5,540 C608.671573,540 608,539.328427 608,538.5 C608,537.671573 608.671573,537 609.5,537 Z M609.5,545 L636.2,545 C637.028427,545 637.7,545.671573 637.7,546.5 C637.7,547.328427 637.028427,548 636.2,548 L609.5,548 C608.671573,548 608,547.328427 608,546.5 C608,545.671573 608.671573,545 609.5,545 Z",
    id: "packed_l_n"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackedLN);
export default __webpack_public_path__ + "static/media/packed_l_n.9b054229654c32d4fac5289946a4a7ba.svg";
export { ForwardRef as ReactComponent };